import { useNavigate } from 'react-router-dom';

import SwitchHorizontal from '@/assets/svgs/switch-horizontal.svg?react';
import { Text } from '@/components/Text';
import { Button } from '@/components/ui/button';
import { accountRestStorage } from '@/lib/data/domains/account';
import { restService } from '@/lib/utils';
import { useAuthStore } from '@/store/auth';
import { useImpersonationStore } from '@/store/impersonation';

export const ImpersonationBanner = () => {
  const navigate = useNavigate();

  const {
    isImpersonating,
    impersonatedUser,
    adminUser,
    adminToken,
    stopImpersonation,
  } = useImpersonationStore();
  const { setUser } = useAuthStore();
  const { fetchUser } = accountRestStorage;

  if (!isImpersonating || !impersonatedUser) return null;

  const handleStop = async () => {
    if (!adminToken) return;

    // Restore admin token
    restService.setCurrentToken(adminToken);

    try {
      // Re-fetch the admin user's profile to ensure it's fresh
      const { data: refreshedAdmin } = await fetchUser({});
      setUser(refreshedAdmin ?? adminUser);
    } catch {
      // Fall back to cached admin user
      setUser(adminUser);
    }

    stopImpersonation();
    navigate('/impersonation');
  };

  return (
    <div className='fixed top-[72px] sm:top-0 left-0 right-0 sm:left-64 z-50 bg-inReview px-4 py-2 flex items-center justify-between gap-4'>
      <div className='flex items-center gap-2 min-w-0'>
        <SwitchHorizontal className='shrink-0 size-5! text-white' />
        <Text renderAs='psmallbold' className='text-white truncate'>
          Impersonating:{' '}
          <span className='font-normal'>
            {impersonatedUser.firstName} {impersonatedUser.lastName} (
            {impersonatedUser.email})
          </span>
        </Text>
      </div>

      <Button
        type='button'
        variant='ghost'
        classNames={{ text: 'text-white' }}
        onClick={handleStop}
      >
        Stop impersonating
      </Button>
    </div>
  );
};
